import { render, staticRenderFns } from "./diff_gutter_toggle.vue?vue&type=template&id=2732379a&vue3"
import script from "./diff_gutter_toggle.vue?vue&type=script&lang=js&vue3"
export * from "./diff_gutter_toggle.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports